export const ParseFloat = (str = '') => {
	return parseFloat(str.replace(/[$,]/g, ''));
};
